module.exports = __webpack_public_path__ + "img/menu2.fb0a1764.png";